import { Box } from "@mantine/core";
import type {
  LegacyHistoricalReportResolvedAsset,
  LegacyHistoricalReportSignature,
} from "../../types/legacyHistoricalReport";
import { LegacyHistoricalGraphic } from "./LegacyHistoricalGraphic";
import { LegacyHistoricalText } from "./LegacyHistoricalText";

interface Props {
  signature: LegacyHistoricalReportSignature;
  assets?: LegacyHistoricalReportResolvedAsset[];
}

export function LegacyHistoricalSignature({ signature, assets }: Props) {
  return (
    <Box
      data-historical-signature-id={signature.id}
      data-after-section-id={signature.afterSectionId}
      style={{ breakInside: "avoid", pageBreakInside: "avoid" }}
    >
      {signature.asset ? (
        <LegacyHistoricalGraphic
          asset={signature.asset}
          assets={assets}
          description={signature.text || "Historical signature block"}
        />
      ) : (
        <LegacyHistoricalText text={signature.text} />
      )}
    </Box>
  );
}
